import { useQuery } from "@tanstack/react-query";
import { getUsageSummary } from "../actions/get-usage-summary.action";

export const USAGE_SUMMARY_KEY = "usage-summary";

export const useUsageSummaryQuery = (phoneNumber?: string, billingPeriod?: string) => {
  return useQuery({
    queryKey: [USAGE_SUMMARY_KEY, phoneNumber, billingPeriod],
    queryFn: () =>
      getUsageSummary({
        phoneNumber: phoneNumber!,
        billingPeriod,
      }),
    enabled: Boolean(phoneNumber),
    staleTime: 0,
    gcTime: 5 * 60_000,
    retry: 1,
  });
};
